// @ts-nocheck
import { useEffect, useState } from 'react'
import SidePanel from './SidePanel'
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Checkbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function CloneLeagueModal({
  open,
  onClose,
  onSubmit,
  data,
  seasons = [],
  // Copy pack so this modal can be reused across entity types (season /
  // tournament / division) — OrganizeAdmin passes its CLONE_COPY entry
  // wholesale. Omitted fields fall back to the original season-clone wording.
  copy = {},
  // Optional second checkbox — used by the tournament-clone path to also
  // clone the source tournament's Registration document.
  showRegistrationCheckbox = false,
}) {
  const {
    title,
    description = 'Clone this season with a new name. You can optionally clone divisions as well.',
    nameLabel = 'Season Name',
    namePlaceholder = 'Enter season name',
    childrenLabel = 'Clone Divisions',
    // Divisions have no children, so the clone-children checkbox is hidden for them.
    showChildren = true,
    duplicateMessage = 'A season with this name already exists. Please choose a different name.',
  } = copy;
  // The submit button mirrors the drawer title (OrganizeAdmin always passed
  // the same string for both), keeping the legacy wording as the fallback.
  const submitLabel = title || 'Clone Season';
  const [seasonName, setSeasonName] = useState('');
  const [cloneDivisions, setCloneDivisions] = useState(false);
  const [cloneRegistration, setCloneRegistration] = useState(false);

  console.log('CloneLeagueModal::seasons::', seasons);

  useEffect(() => {
    if (data && data.name) {
      setSeasonName(`${data.name} Copy`);
    } else {
      setSeasonName('');
    }
    setCloneDivisions(false);
    setCloneRegistration(false);
  }, [data, open]);

  // Check if season name already exists (case-insensitive, excluding current season)
  const isDuplicateName = () => {
    if (!seasonName.trim()) {
      return false;
    }
    const trimmedName = seasonName.trim().toLowerCase();
    return seasons.some(season => {
      if (!season.name) {
        return false;
      }
      const tempSeasonName = season.name.trim().toLowerCase();
      console.log(`season.name::${season.name.toLowerCase()}::trimmedName::${trimmedName}`);
      return tempSeasonName === trimmedName;
    });
  };

  const duplicateName = isDuplicateName();

  const handleSubmit = () => {
    if (!seasonName.trim() || duplicateName) {
      return;
    }
    onSubmit({
      seasonName: seasonName.trim(),
      cloneDivisions,
      cloneRegistration,
    });
  };

  const handleClose = () => {
    setSeasonName('');
    setCloneDivisions(false);
    setCloneRegistration(false);
    onClose();
  };

  return (
    <SidePanel
      open={open}
      onClose={handleClose}
      title={title}
      description={description}
      footer={
        <div className="flex justify-end gap-2 w-full">
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={!seasonName.trim() || duplicateName}>
            {submitLabel}
          </Button>
        </div>
      }
    >
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="seasonName">{nameLabel}</Label>
            <Input
              id="seasonName"
              value={seasonName}
              onChange={(e) => setSeasonName(e.target.value)}
              placeholder={namePlaceholder}
              required
              className={duplicateName ? "border-destructive" : ""}
            />
            {duplicateName && (
              <p className="text-sm text-destructive mt-1">
                {duplicateMessage}
              </p>
            )}
          </div>
          {/* Hidden for entities with no children to clone (a division). */}
          {showChildren && (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={cloneDivisions}
                    onChange={(e) => setCloneDivisions(e.target.checked)}
                  />
                }
                label={childrenLabel}
              />
            </div>
          )}
          {showRegistrationCheckbox && (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={cloneRegistration}
                    onChange={(e) => setCloneRegistration(e.target.checked)}
                  />
                }
                label="Clone Registration"
              />
            </div>
          )}
        </div>
    </SidePanel>
  )
}
